import Vue from 'vue'
import Vuex from 'vuex'

import generalModule from './modules/general'
import scheduleModule from './modules/schedule'
import tipsModule from './modules/tips'
import discountCodesModule from './modules/discountCodes'
import userModule from './modules/user'
import patientsModule from './modules/patients'
import statisticsModule from './modules/statistics'
import adminsModule from './modules/admins'
import paymentsModule from './modules/payments'
import psychologistsModule from './modules/psychologists'
import companiesModule from './modules/companies'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        general: generalModule,
        schedule: scheduleModule,
        tips: tipsModule,
        discountCodes: discountCodesModule,
        user: userModule,
        admins: adminsModule,
        psychologists: psychologistsModule,
        patients: patientsModule,
        statistics: statisticsModule,
        payments: paymentsModule,
        companies: companiesModule
    }
})
